import React from 'react'
import PropTypes from 'prop-types'
import $ from 'jquery'
import AppStore from '../../stores/AppStore'
import TemplateData, { localsMessages } from '../../utility/getTemplateData'
import { hideSpinnerOverlay, setFocus } from '../../utility/helper';
import PostTransaction from '../confirmation/postTransaction'
import * as FPT from '../../utility/fpt'
import _isFunction from 'lodash/isFunction';
import { hideLanguageSelector } from '../../utility/languageSelector';
import { Icon, Button, Text } from '@paypalcorp/pp-react';
import ConfirmationDisplayMyAccount from '../../confirmation/ConfirmationDisplayMyAccount';
import Illustration from '../../components/illustrations/Illustration';
import ConfirmationTitle from '../../confirmation/ConfirmationTitle';
import ConfirmationBody from '../../confirmation/ConfirmationBody';

const messages = localsMessages('confirmation/pending')

export default class extends React.Component {
    static propTypes = {
		label: PropTypes.string
	};

    constructor(props) {
        super(props);

        let confirmationData = AppStore.getConfirmation() || {}

        this.state = {
			amount: confirmationData.amount || '',
			postBackData: confirmationData.postBackData || {},
			syncReturnUrl: confirmationData.syncReturnUrl || '',
			displayMyAccount: confirmationData.showAccountOverview || false,
			orgName: TemplateData.donationName ? TemplateData.donationName : '',

			autoRedirect: TemplateData.returnAutoRedirect !== '',
			autoRedirectUrl: (TemplateData.charityReturnUrl) ? TemplateData.charityReturnUrl : '',
			autoRedirectMethod: (TemplateData.returnMethod) ? TemplateData.returnMethod : ''
		};
    }

    componentDidMount() {
		this.isComponentMounted = true;
		hideLanguageSelector();

		this.serverRequest = $.post('/donate/guest/postTransaction', {}).then((response) => {
			hideSpinnerOverlay();
			setFocus();
			if (response.data.confirmationData) {
				if (this.isComponentMounted) {
					this.updatePendingData(response);
				}
			}
		})

		let confData = AppStore.getConfirmation() || {}
		let trid = confData.confirmationNumber || '';

		if (TemplateData.fptPageName === 'guestULSignUp') {
			FPT.trackPage('main:donate:wps:signup:pending', 'main:donate:wps:signup:pending:web::', 'trid', trid)
		} else {
			FPT.trackPage('main:donate:wps:guest:pending', 'main:donate:wps:guest:pending:web::', 'trid', trid)
		}
	}

    updatePendingData = (response) => {
		this.setState({
			amount: response.data.confirmationData.amount || AppStore.getDonationAmount(),
			guestSignUp: response.data.confirmationData.guestSignUp || false,
			displayMyAccount: response.data.confirmationData.showAccountOverview || false
		})
	};

    componentWillUnmount() {
		this.isComponentMounted = false;
		if (this.serverRequest && _isFunction(this.serverRequest.abort)) {
			this.serverRequest.abort()
		}
	}

	handleAutoRedirect = () => {
		let finalUrl = this.state.autoRedirectUrl
		if (finalUrl.indexOf('http') != 0 && finalUrl.indexOf('//') != 0) {
		    finalUrl = '//' + finalUrl;
		}

		window.location.href = finalUrl
	}

    handleMyAccount = () => {
		FPT.trackLinkClick('myAccount');
		window.location.href = '/myaccount'
	};

    render() {

		let returnTextMember = messages.label && messages.label.returnTextMember || ''
		let returnto = messages.label && messages.label.returnto || ''
		let myAccount = messages.label && messages.label.myAccount || ''
		let pending = messages.label && messages.label.pending || ''
		let pending2 = messages.label && messages.label.pending2 || ''

		returnTextMember = returnTextMember.replace('{orgName}', this.state.orgName)

		returnto = returnto.replace('{orgName}', this.state.orgName)

		return (
			<div>
				<div className="donate_wrapper confirmation">
					<div className="ppvx_row">
						<div className="ppvx_col-12">
							<div className="ppvx_col-12 ppvx_d-flex ppvx_justify-content-center">
	        					<Illustration type="warning" />
	        				</div>
						</div>
					</div>
					<div className="ppvx_row">
						<div className="ppvx_col-12 text-center">
							<ConfirmationTitle message={pending} />
						</div>
					</div>
					<div className="ppvx_row">
						<div className="ppvx_col-12 text-center">
							<ConfirmationBody message={pending2} />
						</div>
					</div>

					{this.state.autoRedirect &&
						<div className="ppvx_row">
							<div className="ppvx_col-12">
								{
									this.state.orgName ?
									<div className="text-center">
										<a id="returnUrl" href="#" onClick={this.handleAutoRedirect}>{returnTextMember}</a>
									</div> :
									<div className="text-center">
										<a id="returnUrl" href="#" onClick={this.handleAutoRedirect}>{returnto}</a>
									</div>
								}
							</div>
						</div>
					}

					{(this.state.displayMyAccount && !this.state.autoRedirect) &&
						<div className="ppvx_row">
							<div className="ppvx_col-sm-12">
								<ConfirmationDisplayMyAccount
									handleMyAccount={this.handleMyAccount}
									myAccount={myAccount}
								/>
							</div>
						</div>
					}
				</div>
			</div>
		);
	}
}
